module.exports = __webpack_public_path__ + "static/circleup-24bd0a23be905aa7db2c66bc56c9f2a9.png";